<!-- 创建时间2021/12/03 17:12:12 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：量表题的拖动条 -->
<template>
  <div class="survey-slider" :class="larger?'is-large':''">
    <div ref="barTooltip" class="survey-slider__bar-wrap" @mousedown="start">
      <yxt-tooltip ref="buttonTooltip" :content="value_.toString()">
        <div ref="bar" class="survey-slider__bar bg-primary-6 pointer"/>
      </yxt-tooltip>
    </div>

    <div ref="cover" class="survey-slider__cover bg-primary-6"></div>
    <div class="flex flex-between survey-slider__tick">
      <yxt-tooltip v-for="(item,index) in computedLength"
                   :key="item"
                   :disabled="operationType!=='hover' || (quesType !== SurveyQuesType.score&&quesType !== SurveyQuesType.evaluation)"
                   :content="getTooltipContent(item)">
        <div class="survey-slider__tick-item-wrap">
          <div class="survey-slider__tick-item-wrap" @click="change(item)">
            <div class="survey-slider__tick-item"
                 :class="{'bg-primary-6-i':value_>=item}">
                 <div v-if="showSlot('label')" class="survey-slider__label"><slot name="label" :index="item"></slot></div>
                 <div class="survey-slider__tick-item-text">{{ item }}</div>
            </div>
          </div>
        </div>
      </yxt-tooltip>
    </div>
    <div class="survey-slider__line"></div>
  </div>
</template>

<script>
// import { SurveyQuesType } from '@/core/enum';
export default {
  name: 'SliderBar',
  props: {
    length: {
      type: Number,
      default: 11
    },
    value: {
      type: Number,
      default: 3
    },
    larger: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    quesType: {
      type: Number,
      default: 0
    },
    operationType: {
      type: String,
      default: 'none' // none 全灰色，无法操作 single 单个选择  range 范围选择, hover 预览时的hover
    },
    showAllTick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      originLeft: 0,
      originX: 0,
      colorTickLength: 0, // 需要变色的tick个数，注意拖动过程中的变色
      value_: 10,
      SurveyQuesType: {
        score: 10,
        evaluation: 3,
        scale: 10,
        multiScale: 2
      }
    };
  },
  computed: {
    computedLength() {
      const length = [this.SurveyQuesType.scale, this.SurveyQuesType.multiScale, this.SurveyQuesType.evaluation].includes(this.quesType) ? this.length + 1 : this.length;
      return new Array(length - this.actualMin).fill('').map((v, i) => i + this.actualMin);
    },
    minLeft() {
      return this.showAllTick ? 0 : 10;
    },
    actualMin() {
      return [this.SurveyQuesType.scale, this.SurveyQuesType.multiScale, this.SurveyQuesType.evaluation].includes(this.quesType) ? this.min + 1 : this.min;
    }
  },
  watch: {
    value(val) {
      if (this.value_ !== val) {
        this.value_ = (!this.value || this.actualMin > this.value) ? this.actualMin : this.value;
        this.setBarLeft(val);
        this.setCoverWidth(val);
      }
    }
  },
  mounted() {
    this.value_ = (!this.value || this.actualMin > this.value) ? this.actualMin : this.value;
    this.setBarLeft(this.value_);
    this.setCoverWidth(this.value_);
  },
  methods: {
    setBarLeft(value = 0) {
      // let w = this.$el.offsetWidth;
      let w = 100;
      const left = Math.max(this.minLeft, (value - this.actualMin) / (this.computedLength.length - 1) * w);
      this.$refs.barTooltip.style.left = left / w * 100 + '%';
    },
    setCoverWidth(value = 0) {
      // let w = this.$el.offsetWidth;
      let w = 100;
      const width = Math.max(this.minLeft, (value - this.actualMin) / (this.computedLength.length - 1) * w);
      this.$refs.cover.style.width = width / w * 100 + '%';
    },
    showSlot(name) {
      return this.$scopedSlots[name];
    },
    start(e) {
      this.originLeft = e.target.parentNode.offsetLeft;
      this.originX = e.clientX;
      if (!this.readonly) {
        window.addEventListener('mousemove', this.move);
        window.addEventListener('mouseup', this.end);
      }
    },
    move(e) {
      this.$refs.buttonTooltip && (this.$refs.buttonTooltip.showPopper = true);
      let length = e.clientX - this.originX;
      let step = Math.min(Math.max(this.minLeft, this.originLeft + length), this.$el.offsetWidth);
      this.$refs.barTooltip.style.left = step + 'px';
      this.$refs.cover.style.width = step + 'px';
      this.value_ = this.calcNumber(false);
      this.$nextTick(() => {
        this.$refs.buttonTooltip && this.$refs.buttonTooltip.updatePopper();
      });
    },
    end() {
      // 计算出value值
      let number = this.calcNumber(true);
      this.$refs.buttonTooltip && (this.$refs.buttonTooltip.showPopper = false);
      this.change(number);
    },
    change(number) {
      if (this.readonly) return;
      // number = Math.max(number, this.actualMin || 0)
      this.value_ = number;
      this.$emit('input', number);
      this.$emit('change', number);
      this.setBarLeft(number);
      this.setCoverWidth(number);
      window.removeEventListener('mousemove', this.move);
      window.removeEventListener('mouseup', this.end);
    },
    calcNumber(auto) {
      let perW = this.$el.offsetWidth / (this.computedLength.length - 1);
      let number = Math.floor(this.$refs.barTooltip.offsetLeft / perW);
      let remain = this.$refs.barTooltip.offsetLeft - number * perW;
      if (auto && remain > perW / 2) {
        number++;
      }
      return number + this.actualMin;
    },
    getTooltipContent(index) {
      if (this.quesType === this.SurveyQuesType.score) {
        return index + this.$t('pc_survey_lbl_scorelabel');
      } else if (this.quesType === this.SurveyQuesType.evaluation) {
        const key = ['', 'pc_survey_lbl_npsunsatisfaction', 'pc_survey_lbl_somedissatisfied', 'pc_survey_lbl_ordinarysatisfaction', 'pc_survey_lbl_somesatisfaction', 'pc_survey_lbl_npssatisfaction'];
        return this.$t(key[index]);
      }
      return '';
    }

  }
};
</script>

<style scoped lang="scss">
  html{height:100%}
  body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
  #app{height:100%}*, :after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;outline:0}
  .flex{display:-webkit-box;display:-ms-flexbox;display:flex}
  .flex-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .survey-slider{
    position:relative;
    height:8px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    width: 500px;
  }
  .survey-slider__bar-wrap{position:absolute;bottom:0;z-index:99}
  .survey-slider__bar{position:relative;width:10px;height:10px;border-radius:50%;-webkit-box-shadow:0 3px 5px 0 var(--color-primary-3);box-shadow:0 3px 5px 0 var(--color-primary-3);-webkit-transform:translateX(-50%) translateY(50%);transform:translateX(-50%) translateY(50%)}
  .survey-slider__bar:after{position:absolute;top:50%;left:50%;width:6px;height:6px;background-color:#fff;border-radius:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);content:""}
  .survey-slider__line{position:relative;top:-1px;height:1px;background-color:#d9d9d9}
  .survey-slider__tick{z-index:20;width:100%;height:8px}
  .survey-slider__tick-item-wrap{position:relative;z-index:20;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:5px 5px 0;cursor:pointer}
  .survey-slider__tick-item-wrap:last-child{padding-right:0}
  .survey-slider__tick-item-wrap:first-child{padding-left:0}
  .survey-slider__tick-item{position:relative;z-index:10;width:1px;height:8px;background-color:#d9d9d9}
  .survey-slider__tick-item.not-show{visibility:hidden}
  .survey-slider__cover{position:absolute;bottom:0;left:0;z-index:9;height:3px;-webkit-transform:translateY(50%);transform:translateY(50%)}
  .survey-slider__label{position:absolute;bottom:-20px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}
  .survey-slider.is-large{height:26px;padding:10px 0 8px 0;margin:0 20px}
  .survey-slider.is-large .survey-slider__bar{width:18px;height:18px;-webkit-transform:translateX(-50%);transform:translateX(-50%)}
  .survey-slider.is-large .survey-slider__bar:after{width:12px;height:12px}
  .survey-slider.is-large .survey-slider__line{top:-3px;height:3px}
  .survey-slider.is-large .survey-slider__tick-item{width:2px}
  .survey-slider.is-large .survey-slider__cover{bottom:6px;height:6px;-webkit-transform:none;transform:none}
  .survey-slider__tick-item-text{
    position: absolute;
    top: 10px;
    left:-2px;
    color:#757575;
    width: 20px;
  }
</style>